import Nav from "../Wifi/Nav";
import Footer from "./Footer";
import React from "react";
import "./Privacy.css";

export default function Privacy() {
  return (
    <section className="privacy-policy">
      <Nav />
      <div className="privacy-policy__container">
        <article className="privacy-policy__card">
          <h1 className="privacy-policy__title">Chính sách bảo mật</h1>

          <div className="privacy-policy__content">
            <p className="privacy-policy__lead-title">Chính sách bảo mật</p>

            <p className="privacy-policy__lead">
              CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ DU LỊCH ÁNH THÁI DƯƠNG cam kết sẽ
              bảo mật tuyệt đối những thông tin của quý khách mang tính riêng tư
              khi đăng ký và mua hàng tại website{" "}
              <a href="/">ruttienthetindungtq.com</a>
            </p>

            <section className="privacy-policy__section">
              <h2>1. Mục đích và phạm vi thu thập thông tin cá nhân:</h2>

              <h3>A - Mục đích</h3>
              <p>
                Mục đích thu thập những thông tin khách hàng thông qua{" "}
                <a href="/">ruttienthetindungtq.com</a> sẽ giúp chúng tôi:
              </p>

              <ul>
                <li>Hướng dẫn và tư vấn giải pháp cho khách hàng.</li>
                <li>Hỗ trợ khách hàng sau khi mua sản phẩm.</li>
                <li>
                  Cung cấp cho bạn thông tin khuyến mại mới nhất trên website.
                </li>
                <li>Xem xét và nâng cấp nội dung và giao diện của website.</li>
                <li>
                  Thực hiện các bản khảo sát về dịch vụ của chúng tôi sau khi
                  bán hàng khách hàng.
                </li>
                <li>
                  Thực hiện các hoạt động quảng bá liên quan đến các sản phẩm và
                  dịch vụ của <a href="/">ruttienthetindungtq.com</a>.
                </li>
              </ul>

              <h3>B - Phạm vi thu thập thông tin cá nhân:</h3>
              <ul>
                <li>
                  Để truy cập và sử dụng một số dịch vụ tại{" "}
                  <a href="/">ruttienthetindungtq.com</a>, khách hàng có thể sẽ
                  được yêu cầu đăng ký với chúng tôi thông tin cá nhân (Email,
                  Họ tên, Số ĐT liên lạc...). Các thông tin này phải đảm bảo
                  tính chính xác và hợp pháp. Chúng tôi không chịu mọi trách
                  nhiệm liên quan đến pháp luật của thông tin khách hàng đã khai
                  báo.
                </li>
                <li>
                  Chúng tôi cũng có thể thu thập thông tin về số lần ghé thăm
                  của khách hàng bao gồm: số trang khách xem, số links (liên
                  kết) đã click và những thông tin khác liên quan đến việc kết
                  nối đến <a href="/">ruttienthetindungtq.com</a>.
                </li>
                <li>
                  Chúng tôi cũng thu thập các thông tin mà trình duyệt Web
                  (Browser) khách hàng sử dụng mỗi khi truy cập vào website bao
                  gồm: địa chỉ IP, loại trình duyệt, ngôn ngữ sử dụng, thời gian
                  và những địa chỉ mà trình duyệt truy xuất đến...
                </li>
              </ul>
            </section>

            <section className="privacy-policy__section">
              <h2>2. Phạm vi sử dụng thông tin cá nhân:</h2>
              <ul>
                <li>
                  Chúng tôi thu thập và sử dụng thông tin cá nhân quý khách với
                  mục đích phù hợp và hoàn toàn tuân thủ nội dung của “Chính
                  sách bảo mật” này.
                </li>
                <li>
                  Khi cần thiết, chúng tôi có thể sử dụng những thông tin này để
                  liên hệ trực tiếp với bạn dưới các hình thức như: Gọi điện,
                  gửi thư, đơn đặt hàng, thư cảm ơn, thông tin về kỹ thuật và
                  bảo mật, khách hàng có thể nhận được thư định kỳ cung cấp
                  thông tin sản phẩm hoặc dịch vụ mới, những thông tin về các sự
                  kiện sắp tới hoặc thông tin tuyển dụng nếu quý khách đăng kí
                  nhận email thông báo.
                </li>
              </ul>
            </section>

            <section className="privacy-policy__section">
              <h2>3. Thời gian lưu trữ thông tin</h2>
              <p>
                <a href="/">ruttienthetindungtq.com</a> sẽ lưu trữ các Thông tin
                cá nhân do Khách hàng cung cấp trên các hệ thống nội bộ của
                chúng tôi trong quá trình cung cấp dịch vụ cho Khách hàng hoặc
                cho đến khi hoàn thành mục đích thu thập hoặc khi Khách hàng có
                yêu cầu hủy các thông tin đã cung cấp.
              </p>
            </section>

            <section className="privacy-policy__section">
              <h2>4. Thông tin liên hệ:</h2>
              <ul>
                <li>
                  Chúng tôi luôn lắng nghe các ý kiến đóng góp, liên hệ và phản
                  hồi thông tin từ bạn về “Chính sách bảo mật” này. Nếu bạn có
                  những thắc mắc liên quan xin vui lòng liên hệ
                </li>
              </ul>

              <div className="privacy-policy__contact">
                <p>CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ DU LỊCH ÁNH THÁI DƯƠNG</p>
                <p>
                  Đ/C : 131 Đường Số 7, Phường Hạnh Thông, TP Hồ Chí Minh, Việt
                  Nam
                </p>
                <p>Hotline : 0867 529 641</p>
                <p>
                  Email : daicaxomtro2m8@gmail.com | Website :{" "}
                  <a href="/">ruttienthetindungtq.com</a>
                </p>
              </div>
            </section>

            <section className="privacy-policy__section">
              <h2>
                5. Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ
                liệu cá nhân:
              </h2>
              <p>
                Bất cứ thời điểm nào khách hàng có thể thực hiện các quyền trên
                bằng cách tự truy cập vào website hoặc liên hệ với chúng tôi qua
                email hoặc địa chỉ liên lạc được công bố trên website của{" "}
                <a href="/">ruttienthetindungtq.com</a>
              </p>
            </section>

            <section className="privacy-policy__section">
              <h2>6. Cam kết Bảo mật thông tin cá nhân:</h2>
              <ul>
                <li>
                  Khi bạn gửi thông tin cá nhân của bạn cho chúng tôi, bạn đã
                  đồng ý với các điều khoản mà chúng tôi đã nêu ở trên,{" "}
                  <a href="/">ruttienthetindungtq.com</a> cam kết bảo mật thông
                  tin cá nhân của quý khách bằng mọi cách thức có thể. Chúng tôi
                  sẽ sử dụng nhiều công nghệ bảo mật thông tin khác nhau như:
                  chuẩn quốc tế PCI, SSL,... nhằm bảo vệ thông tin này không bị
                  sử dụng hoặc tiết lộ ngoài ý muốn.
                </li>
                <li>
                  Tuy nhiên do hạn chế về mặt kỹ thuật, không một dữ liệu nào có
                  thể được truyền trên đường truyền internet mà có thể được bảo
                  mật 100%. Do vậy, chúng tôi không thể đưa ra một cam kết chắc
                  chắn rằng thông tin quý khách cung cấp cho chúng tôi sẽ được
                  bảo mật một cách tuyệt đối an toàn, và chúng tôi không thể
                  chịu trách nhiệm trong trường hợp có sự truy cập trái phép
                  thông tin cá nhân của quý khách như các trường hợp quý khách
                  tự ý chia sẻ thông tin với người khác.... Nếu quý khách không
                  đồng ý với các điều khoản như đã mô tả ở trên, Chúng tôi
                  khuyên quý khách không nên gửi thông tin đến cho chúng tôi.
                </li>
                <li>
                  Vì vậy, <a href="/">ruttienthetindungtq.com</a> cũng khuyến
                  cáo quý khách nên bảo mật các thông tin liên quan đến mật khẩu
                  truy xuất của quý khách và không nên chia sẻ với bất kỳ người
                  nào khác.
                </li>
                <li>
                  Nếu sử dụng máy tính chung nhiều người, quý khách nên đăng
                  xuất, hoặc thoát hết tất cả cửa sổ Website đang mở.
                </li>
              </ul>
            </section>

            <section className="privacy-policy__section">
              <h2>7. Chia sẻ thông tin cá nhân:</h2>
              <ul>
                <li>
                  Ngoại trừ các trường hợp về Sử dụng thông tin cá nhân như đã
                  nêu trong chính sách này, chúng tôi cam kết sẽ không tiết lộ
                  thông tin cá nhân bạn ra ngoài.
                </li>
                <li>
                  Trong một số trường hợp, chúng tôi có thể thuê một đơn vị độc
                  lập để tiến hành các dự án nghiên cứu thị trường và khi đó
                  thông tin của bạn sẽ được cung cấp cho đơn vị này để tiến hành
                  dự án. Bên thứ ba này sẽ bị ràng buộc bởi một thỏa thuận về
                  bảo mật mà theo đó họ chỉ được phép sử dụng những thông tin
                  được cung cấp cho mục đích hoàn thành dự án.
                </li>
                <li>
                  Chúng tôi có thể tiết lộ hoặc cung cấp thông tin cá nhân của
                  bạn trong các trường hợp thật sự cần thiết như sau:
                </li>
              </ul>

              <div className="privacy-policy__alpha-list">
                <p>(a) Khi có yêu cầu của các cơ quan pháp luật;</p>
                <p>
                  (b) Trong trường hợp mà chúng tôi tin rằng điều đó sẽ giúp
                  chúng tôi bảo vệ quyền lợi chính đáng của mình trước pháp
                  luật;
                </p>
                <p>
                  (c) Tình huống khẩn cấp và cần thiết để bảo vệ quyền an toàn
                  cá nhân của các thành viên{" "}
                  <a href="/">ruttienthetindungtq.com</a> khác.
                </p>
              </div>
            </section>

            <section className="privacy-policy__section">
              <h2>8. Thay đổi về chính sách:</h2>
              <ul>
                <li>
                  Chúng tôi hoàn toàn có thể thay đổi nội dung trong trang này
                  mà không cần phải thông báo trước, để phù hợp với các nhu cầu
                  của <a href="/">ruttienthetindungtq.com</a> cũng như nhu cầu
                  và sự phản hồi từ khách hàng nếu có. Khi cập nhật nội dung
                  chính sách này, chúng tôi sẽ chỉnh sửa lại thời gian “Cập nhật
                  lần cuối” bên dưới.
                </li>
                <li>
                  Nội dung “Chính sách bảo mật” này chỉ áp dụng tại{" "}
                  <a href="/">ruttienthetindungtq.com</a>, không bao gồm hoặc
                  liên quan đến các bên thứ ba đặt quảng cáo hay có links tại
                  website. Chúng tôi khuyến khích bạn đọc kỹ chính sách An toàn
                  và Bảo mật của các trang web của bên thứ ba trước khi cung cấp
                  thông tin cá nhân cho các trang web đó. Chúng tôi không chịu
                  trách nhiệm dưới bất kỳ hình thức nào về nội dung và tính pháp
                  lý của trang web thuộc bên thứ ba.
                </li>
                <li>
                  Vì vậy, bạn đã đồng ý rằng, khi bạn sử dụng website của chúng
                  tôi sau khi chỉnh sửa nghĩa là bạn đã thừa nhận, đồng ý tuân
                  thủ cũng như tin tưởng vào sự chỉnh sửa này. Do đó, chúng tôi
                  đề nghị bạn nên xem trước nội dung trang này trước khi truy
                  cập các nội dung khác trên website cũng như bạn nên đọc và
                  tham khảo kỹ nội dung “Chính sách bảo mật” của từng website mà
                  bạn đang truy cập.
                </li>
              </ul>
            </section>
          </div>
        </article>
      </div>
      <Footer />
    </section>
  );
}
